export enum PageTab {
  Details = 'details',
  VendorTeam = 'team',
  ClientTeam = 'client-team',
  FeeSchedule = 'fee-schedule',
  Conflicts = 'conflicts',
  Policies = 'policies',
  Discount = 'discount'
}
